import script from "./Logo.vue?vue&type=script&lang=ts&setup=true"
export * from "./Logo.vue?vue&type=script&lang=ts&setup=true"

import "./Logo.vue?vue&type=style&index=0&id=559b9d53&lang=scss&scoped=true"

import exportComponent from "/Users/mayo/htdocs/halp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-559b9d53"]])

export default __exports__